@import '../../../globals/main.scss';

@import './pn-marketweb-siteheader-common.scss';

pn-marketweb-siteheader-login {
  padding: 1rem 0;
  max-height: 5.2rem;
  position: relative;
  // Example of how we could indicate username in smaller viewports
  // .siteheader-topright & {
  //     &[username] {
  //         &:hover {
  //             &::after {
  //                 content:attr(username);
  //                 display: block;
  //                 position:absolute;
  //                 z-index: 4;
  //                 background:$white;
  //                 border:.1rem solid $blue700;
  //                 border-radius: .8rem;
  //                 padding:0.5rem 0.9rem;
  //                 margin-top: 0.8rem;
  //                 left: 50%;
  //                 transform: translateX(-50%);
  //                 @media screen and (min-width: $siteheader-media-smalldesktop) {
  //                     content:"";
  //                     display:none;
  //                 }
  //             }
  //         }
  //     }
  // }

  pn-button-dropdown {
    .pn-button-dropdown-container {
      .pn-button-dropdown-content {
        max-width: 350px;
        display: flex;
        flex-direction: column;
        gap: 2.4rem;
        padding: 4rem;

        pn-button {
          width: 100%;
        }

        pn-marketweb-siteheader-unified-login {
          &::after {
            display: block;
            content: '';
            height: 2px;
            background: $gray25;
            width: 100%;
            margin-top: 2.4rem;
          }
        }

        span {
          &::before {
            display: block;
            content: '';
            height: 2px;
            background: $gray25;
            width: 100%;

            margin-bottom: 2.4rem;
          }
        }

        span {
          font-size: 1.4rem;
          color: $gray900;

          a {
            text-decoration: none;
            color: $blue700;
            &:hover {
              text-decoration: underline;
            }
          }

          * {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  pn-button-dropdown {
    display: none;
  }
  &.hydrated {
    pn-button-dropdown {
      display: block;
    }
  }
}
